var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"arrows"},_vm._l((_vm.links),function(link){return _c('li',{key:link.name},[_c('router-link',{attrs:{"to":{ name: link.name, params: {} }}},[_vm._v(_vm._s(link.name)+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }